import { FieldNode } from 'graphql';

export const getFieldArgumentNode = (field: FieldNode, argumentName: string) =>
  field.arguments?.find((argument) => argument.name.value === argumentName);
